import submitUserInput from './saveInputs/submitUserInput';

export default (user) => `
    submitUser (user: {
        ${submitUserInput(user)}
    }) {
        id
    }
`;
